<template>
  <div class="chartImg">
    <div class="chart" ref="chart"></div>
    <div class="msg_box">
      <div class="msg_txt">
        <p class="msg_p">
          <span class="msg_name">高炉矿槽</span>
          <span class="msg_time">02-02 02:02:02</span>
        </p>
      </div>
      <div class="msg_img"></div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

import getOpt from "./chartOpt.js";
import { unwarp } from "@/utils/tools.js";
export default {
  //import引入的组件需要注入到对象中才能使用
components: {},
props: {},
data() {
//这里存放数据
return {
  customerId: this.$store.state.customerId,
  chart: null,
  unit:1,
};
},
//计算属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
  this.getData();
},
unmounted() {
  if (this.chart) {
    this.chart.dispose();
    this.chart = null;
  }
},
//方法集合
methods: {
  async getData() {
    let _this = this;
    this.pmData = {
      xData: [],
      y1Data: [],
      y2Data: [],
    };
    let data = await _this.$apiUtils.get(
      "/newscreen/env/getAllHistoryByType",
      {
        customerId: _this.customerId,
        unit: _this.unit,
      }
    );
    data.forEach((x, index) => {
      let { x_data, day_time, pm10_avg_value, pm25_avg_value } = x;
      if (day_time && day_time.indexOf(" ") != -1) {
        day_time = day_time.split(" ")[1];
      }
      if (pm10_avg_value || pm25_avg_value) {
        this.noData = false;
      }
      this.pmData.xData.push(day_time);
      this.pmData.y1Data.push(pm10_avg_value);
      this.pmData.y2Data.push(pm25_avg_value);
    });
    this.$nextTick(() => {
      if (!this.chart) {
        this.chart = echarts.init(this.$refs.chart);
      }
      let optionStr = getOpt(this.pmData);
      unwarp(this.chart).setOption(optionStr);
    });
  },
},
}
</script>
<style lang="scss" scoped>
  .chartImg{
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    .chart,.msg_box{
      width: 50%;
      height: 200px;
    }
    .msg_box{
      .msg_txt{
        .msg_p{
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
          .msg_name{
            font-size: 20px;
          }
          .msg_time{
            font-size: 14px;
          }
        }
      }
      .msg_img{
        @include bg-box(100%,150px,"example.png")
      }
    }
  }
</style>